import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import BlogListPage from "../pages/blog/page";
import BlogDetailPage from "../pages/blog/detail";
import PricingPage from "../pages/pricing/page";
import DashboardPage from "../pages/dashboard/page";
import BusinessPage from "../pages/business/page";
import ProductsPage from "../pages/products/page";
import IndustryPage from "../pages/industry/page";
import NewsPage from "../pages/news/page";
import NewsDetailPage from "../pages/news/detail";
import SupportPage from "../pages/support/page";
import ContactPage from "../pages/contact/page";
import LoginPage from "../pages/login/page";
import PrivacyPage from "../pages/privacy/page";
import TermsPage from "../pages/terms/page";
import CopyrightPage from "../pages/copyright/page";
import ManufacturingSolutionPage from "../pages/solutions/manufacturing/page";
import LogisticsSolutionPage from "../pages/solutions/logistics/page";
import DatacenterSolutionPage from "../pages/solutions/datacenter/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/blog", element: <BlogListPage /> },
  { path: "/blog/:slug", element: <BlogDetailPage /> },
  { path: "/pricing", element: <PricingPage /> },
  { path: "/dashboard", element: <DashboardPage /> },
  { path: "/business", element: <BusinessPage /> },
  { path: "/business/:service", element: <BusinessPage /> },
  { path: "/products", element: <ProductsPage /> },
  { path: "/products/:product", element: <ProductsPage /> },
  { path: "/industry", element: <IndustryPage /> },
  { path: "/industry/:id", element: <IndustryPage /> },
  { path: "/news", element: <NewsPage /> },
  { path: "/news/:id", element: <NewsDetailPage /> },
  { path: "/support", element: <SupportPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/solutions/manufacturing", element: <ManufacturingSolutionPage /> },
  { path: "/solutions/logistics", element: <LogisticsSolutionPage /> },
  { path: "/solutions/datacenter", element: <DatacenterSolutionPage /> },
  { path: "/solutions/steel", element: <IndustryPage /> },
  { path: "/solutions/cement", element: <IndustryPage /> },
  { path: "/solutions/chemical", element: <IndustryPage /> },
  { path: "/solutions/power", element: <IndustryPage /> },
  { path: "/solutions/equipment", element: <IndustryPage /> },
  { path: "/solutions/export", element: <IndustryPage /> },
  { path: "/solutions/park", element: <IndustryPage /> },
  { path: "/privacy", element: <PrivacyPage /> },
  { path: "/terms", element: <TermsPage /> },
  { path: "/copyright", element: <CopyrightPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;